import { Divider } from 'antd';
import LoginErrorImg from '../../assets/images/LoginErrorImg.svg';
import { ButtonGroup } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../redux/store';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { selectFlowStep } from '../../redux/headerSlice';
import { isLoading } from '../../redux/loaderSlice';
import { REDIRECTION_URL, ROUTES_PATH } from '../../utils/constants';
import { EventMessageService } from '../../services/EventMessage';
import { StorageService } from '../../services/Storage';
import InsightService from '../../services/Insight';

export const LoginError = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pepperOne = useSelector((state: IRootState) => state.params.value.pepperOne);

  const cancelProcess = () => {
    InsightService.logTrace('LoginError', [
      { LoginError: true },
      { ActiveQuit: true },
    ]);
    pepperOne && EventMessageService.sendMessageEvent('cancel');
    StorageService.deleteStorage();
    window.location.href = REDIRECTION_URL;
  }

  const retry = () => {
    dispatch(isLoading(true));
    navigate(ROUTES_PATH.LOGIN);
  }

  useEffect(() => {
    dispatch(selectFlowStep(null));
  }, [])
  

  return (
    <div className='pepper-status-page pepper-page-padding' id='error'>
      <img src={LoginErrorImg} alt='pepper-login-error'/>
      <div className='pepper-status-text-body'>
        <div className='pepper-title-center'>Algo está fallando...</div>
        <div className='pepper-subtitle'>Alguno de tus datos no es correcto. Por favor, confirma que todos tus datos están bien para vincular tu cuenta.</div>
      </div>
      <Divider />
      <p>En caso de duda, ponte en contacto con tu banco.</p>
      <ButtonGroup continueMsg='Volver a intentar' cancelMsg='Entendido' handleOk={retry} handleCancel={cancelProcess} hideCancelBtn />
    </div>
  )
}
